import { resolutionsNum } from "../constants/resolutions";
import moment from "moment";
import {
  allPointsChoose,
  fourthPointChoose,
  ONBOARDING_ID,
  prePaywallCourseFirstItems,
  prePaywallPoints,
  twoPointsChooseAdditional,
} from "../constants/data";
import { setUserId, setUserProperties } from "firebase/analytics";
import { analytics } from "../firebaseAnalytics";
import {
  appOpenEventAmplitude,
  firstLaunchEventAmplitude,
  setUserIdAmplitude,
  setUserPropertiesAmplitude,
} from "../amplitude/events";
import { appOpenEvent, firstLaunchEvent } from "../firebaseAnalytics/events";
import amplitude from "amplitude-js";
import {
  isMobileOnly,
  isDesktop,
  isTablet,
  osVersion,
  osName,
} from "react-device-detect";
import axios from "axios";

export const checkDevice = (currentResolution, setDeviceFunction) => {
  if (currentResolution > resolutionsNum.mobile) {
    setDeviceFunction("desktop");
  } else {
    setDeviceFunction("mobile");
  }
};

export const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export function redirectToStoreFunction(isRedirectFromPreLand, city, state, zip, country) {
  const url = window.location.href;
  let params = new URL(url).searchParams;
  const fbclid = params.get("fbclid");
  const fbpid = isRedirectFromPreLand ? getFbpFromCookie() : params.get("fbpid");
  // const tracker = params.get("p0")
  const campaignName = params.get("p1");
  const campaignId = params.get("p2");
  const adsetGroup = params.get("p3");
  const adsetId = params.get("p4");
  const adName = params.get("p5");
  const adId = params.get("p6");
  let newLink = `https://app.adjust.com/r1dw79i?campaign=${campaignName}%20%28${campaignId}%29&adgroup=${adsetGroup}%20%28${adsetId}%29&creative=${adName}%20%28${adId}%29&fbclid=${fbclid}&fbpid=${fbpid}`;

  if (isRedirectFromPreLand) {
    newLink = `https://app.adjust.com/r1dw79i?campaign=${campaignName}%20%28${campaignId}%29&adgroup=${adsetGroup}%20%28${adsetId}%29&creative=${adName}%20%28${adId}%29&fbclid=${fbclid}&fbpid=${fbpid}&fb_ct=${city}&fb_st=${state}&fb_zp=${zip}&fb_country=${country}`
  }
  window.location.href = newLink;
}

export function fadeOutFunction() {
  const fadeOutElements = document.querySelectorAll(".visible");
  fadeOutElements.forEach((element) => {
    element.classList.remove("visible");
  });
}

export function fadeInFunction() {
  const fadeOutElements = document.querySelectorAll(".animated");
  fadeOutElements.forEach((element) => {
    element.classList.add("visible");
  });
}

export function userIdGenerator() {
  return `f${(+new Date()).toString(16)}`;
}

export function uuid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    let r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16).toUpperCase();
  });
}

export function getCurrentTimeInFormat() {
  return {
    formatTime: moment().format("YYYY-MM-DD HH:mm:ss"),
    tsTime: moment().unix() * 1000,
  };
}

export function getFinishTimeInFormat() {
  return {
    formatTime: moment().add(1, "week").format("hh:mm A, MMM DD, YYYY"),
    tsTime: moment().unix() * 1000,
  };
}

export function getCurrentYear() {
  return moment().format("YYYY");
}

export function createEventObjectFunction(
  name,
  onboardingId,
  landingId,
  advPropertyObj
) {
  console.log(advPropertyObj);
  const timeObj = getCurrentTimeInFormat();
  let eventObj = {
    client_event_time: timeObj.formatTime || "none",
    onboarding_id: onboardingId || ONBOARDING_ID,
  };
  if (landingId) {
    eventObj.landing_id = landingId;
  }
  if (advPropertyObj) {
    console.log(eventObj);
    eventObj = { ...eventObj, ...advPropertyObj };
  }
  if (name) {
    eventObj.step = name;
  }
  return eventObj;
}

export function setExperimentsFirebaseValue(config) {
  let resultString = "";
  Array.isArray(config) &&
    config.forEach((configObj, index) => {
      const str = `${Object.entries(configObj)[0][0]}=${
        Object.entries(configObj)[0][1]
      }`;
      resultString =
        resultString + str + `${index === config.length - 1 ? "" : ","}`;
    });
  return resultString;
}

export function setExperimentsAmplitudeValue(config) {
  return true;
}

export function getIpAddress(setIpFunction) {
  return fetch("https://api.ipify.org?format=json")
    .then((res) => res.json())
    .then((data) => setIpFunction(data.ip));
}

export function redirectFunction(ip) {
  let userAgent = window.navigator.userAgent;
  console.log(userAgent);
  // if (
  //   (userAgent.includes("FBAN") || userAgent.includes("FBAV")) &&
  //   (userAgent.includes("iPad") || userAgent.includes("iPhone"))
  // ) {
  //   let url = window.origin + "/#" + "/";
  //   window.location = `ftp://${ip}/go.html?url=${url}`;
  // }
  let url = window.origin + "/#" + "/";
  window.location = `ftp://journey.dev.dynevo.org/bridge.html`;
}

export function addTimeFunction(amount, unit) {
  return moment().add(amount, unit).format("hh:mm A, MMMM DD, YYYY");
}

export function setNeededPlan(pointsArray) {
  switch (pointsArray.length) {
    case 1:
      return [
        ...prePaywallCourseFirstItems,
        ...prePaywallPoints[pointsArray[0]],
      ];
    case 2:
      return [
        ...prePaywallCourseFirstItems,
        prePaywallPoints[pointsArray[0]][0],
        prePaywallPoints[pointsArray[1]][0],
        ...twoPointsChooseAdditional,
      ];
    case 3:
      return [
        ...prePaywallCourseFirstItems,
        prePaywallPoints[pointsArray[0]][0],
        prePaywallPoints[pointsArray[1]][0],
        prePaywallPoints[pointsArray[2]][0],
        prePaywallPoints[pointsArray[2]][3],
      ];
    case 4:
      return [...prePaywallCourseFirstItems, ...allPointsChoose];
  }
}

export function analyticsInitFunction(remoteConfig) {
  const firebaseExperiments = setExperimentsFirebaseValue(
    remoteConfig.experiments
  );
  // init amplitude analytics
  amplitude.getInstance().init(process.env.REACT_APP_API_KEY_AMPLITUDE, null, {
    includeUtm: true,
    includeGclid: true,
    includeFbclid: true,
    includeReferrer: true,
  });
  amplitude.getInstance().setVersionName(process.env.REACT_APP_VERSION);
  // firebase
  setUserProperties(analytics, { experiments: firebaseExperiments });
  // amplitude
  setUserPropertiesAmplitude({ experiments: remoteConfig.experiments });
}

export function analyticsSetFunction(
  setUser,
  setEventObject,
  eventObj,
  landingId,
  onboardingId,
  deviceWeb,
  osWeb
) {
  let userId = localStorage.getItem("userId");
  setUser(userId);
  console.log(window.navigator);
  console.log(screen.width);
  console.log(screen.height);
  const timeObj = getCurrentTimeInFormat();
  // const eventObj = createEventObjectFunction();
  setEventObject(eventObj);
  if (!localStorage.getItem("userId")) {
    userId = uuid();
    localStorage.setItem("userId", userId);
    const userObjFirebase = {
      userid: userId,
      first_launch_date: timeObj.formatTime,
      first_launch_date_ts: timeObj.tsTime,
      onboarding_id: onboardingId || ONBOARDING_ID,
      landing_id: landingId,
      app_version: process.env.REACT_APP_VERSION,
      browser: window.navigator.userAgent,
      device_screen_width: screen.width,
      device_screen_length: screen.height,
      device_screen_viewport: `${screen.width}x${screen.height}`,
      device_web: deviceWeb,
      OS_web: osWeb
    };
    const userObj = {
      first_launch_date: timeObj.formatTime,
      first_launch_date_ts: timeObj.tsTime,
      onboarding_id: onboardingId || ONBOARDING_ID,
      landing_id: landingId,
      browser: window.navigator.userAgent,
      device_screen_width: screen.width,
      device_screen_length: screen.height,
      device_screen_viewport: `${screen.width}x${screen.height}`,
      device_web: deviceWeb,
      OS_web: osWeb
    };
    // firebase
    setUserId(analytics, userId);
    setUserProperties(analytics, userObjFirebase);
    // amplitude
    setUserIdAmplitude(userId);
    setUserPropertiesAmplitude(userObj);
    // Событие №1
    firstLaunchEvent(analytics, eventObj);
    firstLaunchEventAmplitude(eventObj);
  } else {
    // отправляем свойства юзера
    const userObjFirebase = {
      userid: userId,
      first_launch_date: timeObj.formatTime,
      first_launch_date_ts: timeObj.tsTime,
      onboarding_id: onboardingId || ONBOARDING_ID,
      landing_id: landingId,
      app_version: process.env.REACT_APP_VERSION,
      browser: window.navigator.userAgent,
      device_screen_width: screen.width,
      device_screen_length: screen.height,
      device_screen_viewport: `${screen.width}x${screen.height}`,
      device_web: deviceWeb,
      OS_web: osWeb
    };
    const userObj = {
      first_launch_date: timeObj.formatTime,
      first_launch_date_ts: timeObj.tsTime,
      onboarding_id: onboardingId || ONBOARDING_ID,
      landing_id: landingId,
      browser: window.navigator.userAgent,
      device_screen_width: screen.width,
      device_screen_length: screen.height,
      device_screen_viewport: `${screen.width}x${screen.height}`,
      device_web: deviceWeb,
      OS_web: osWeb
    };
    // firebase
    setUserId(analytics, userId);
    setUserProperties(analytics, userObjFirebase);
    // amplitude
    setUserIdAmplitude(userId);
    setUserPropertiesAmplitude(userObj);
  }
  // Событие №2
  appOpenEvent(analytics, eventObj);
  appOpenEventAmplitude(eventObj);
}

export function domElementVisible() {}

export function setProductSum(product) {
  const productsSumObj = {
    [process.env.REACT_APP_PRODUCT]: {
      sum: 69.99,
      name: "7-day free trial ",
    },
    [process.env.REACT_APP_PRODUCT_14]: {
      sum: 14.99,
      name: "Subscription $14.99",
    },
    [process.env.REACT_APP_PRODUCT_29]: {
      sum: 29.99,
      name: "Subscription $29.99",
    },
    [process.env.REACT_APP_PRODUCT_69]: {
      sum: 69.99,
      name: "Subscription $69.99",
    },
    [process.env.REACT_APP_PRODUCT_19]: {
      sum: 19.99,
      name: "Subscription 19.99$ in 7 days ",
    },
  };
  return productsSumObj[product];
}

export const setTimeFunction = (setFinishTime, setMillisecondsFinishTime) => {
  const time = moment().add(7, "days").format("hh:mm A, MMMM DD, YYYY");
  const now = new Date();
  const finishDateMilli = new Date();
  finishDateMilli.setDate(now.getDate() + 7);
  setFinishTime(time);
  setMillisecondsFinishTime(Math.floor(finishDateMilli.valueOf() / 1000));
};

export const checkWebDevice = () => {
  if (isMobileOnly) {
    return "Mobile";
  } else if (isTablet) {
    return "Tablet";
  } else if (isDesktop) {
    return "Desktop";
  } else {
    return "Other";
  }
};

export const checkOsVersion = () => {
  if (osVersion === "none") {
    return osName;
  }

  return osName + " " + osVersion;
};

export const getFbpFromCookie = () => {
  const cookiesArr = document.cookie.split(' ');
  let result = cookiesArr.find(elem => elem.substring(0, 4) === '_fbp');

  if (result) {
    result = result.substring(5)

    if (result.slice(-1) === ';') {
      result = result.slice(0, -1);
    }
  } else {
    result = null
  }

  return result
}

export const getGeoInfo = async () => {
  try {
    const geoInfoRes = await axios('https://ipapi.co/json/')

    return geoInfoRes.data
  } catch (e) {
    return null
  }
}

export const encodeCity = (city) => {
  return city.toLocaleLowerCase().split(" ").join("")
}
